import React from 'react';

/**
 * DeadendEscapeButton - Universal escape hatch for deadend scenarios
 * Provides users with a way out when presented with limited options
 * 
 * @param {Object} props
 * @param {Function} props.onClick - Handler for button click
 * @param {string} props.language - Language code ('en' or 'es')
 * @param {string} props.platform - Platform type ('on-device' or 'web')
 * @param {Object} props.style - Optional additional styles
 */
const DeadendEscapeButton = ({ 
  onClick, 
  language = 'en', 
  platform = 'web',
  style = {} 
}) => {
  const label = language === 'es' ? '🔍 Explorar más' : '🔍 Explore more';
  
  // Platform-specific base styles
  const baseStyle = platform === 'on-device' 
    ? {
        border: '1px solid var(--compudopt-green)',
        background: 'transparent',
        color: 'var(--compudopt-green)',
        borderRadius: '999px',
        padding: '8px 16px',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'inherit',
      }
    : {
        border: '1px solid var(--compudopt-green)',
        background: 'transparent',
        color: 'var(--compudopt-green)',
        borderRadius: '999px',
        padding: '6px 10px',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'inherit',
      };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.background = platform === 'on-device' 
      ? 'rgba(142, 196, 65, 0.1)' 
      : '#F0F8E8';
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.background = 'transparent';
  };

  return (
    <button
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ ...baseStyle, ...style }}
      aria-label={language === 'es' ? 'Explorar más opciones' : 'Explore more options'}
    >
      {label}
    </button>
  );
};

export default DeadendEscapeButton;



